export default __webpack_public_path__ + "static/media/search-icon.b6184d39.svg";